import { Suspense } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';

import { OpeningsList } from './openings-list';

interface ActionCenterProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ActionCenter({ isOpen, onOpenChange }: ActionCenterProps) {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="min-w-[500px]">
        <SheetHeader>
          <SheetTitle>
            <FormattedMessage
              defaultMessage="Action center"
              description="Right-side panel title listing at-risk openings and recommendations"
            />
          </SheetTitle>
        </SheetHeader>

        <Suspense fallback={<OpeningsList.Skeleton />}>
          <OpeningsList />
        </Suspense>
      </SheetContent>
    </Sheet>
  );
}
